function getRequiredEnv(name) {
    const value = getConfigValue(name);

    if (!value) {
        throw new Error(`${name} is not provided`);
    }

    return value;
}

function getOptionalEnv(name) {
    return getConfigValue(name) ?? '';
}

function getConfigValue(name) {
    const runtimeConfig = typeof window === 'undefined' ? undefined : window.__SOCIALIZE_CONFIG__;

    return runtimeConfig?.[name] ?? import.meta.env[name];
}

const config = Object.freeze({
    apiUrl: getRequiredEnv('VITE_API_URL'),
    loginGoogleClientId: getOptionalEnv('VITE_LOGIN_GOOGLE_CLIENT_ID'),
    loginFacebookAppId: getOptionalEnv('VITE_LOGIN_FACEBOOK_APP_ID'),
    webPushPublicKey: getOptionalEnv('VITE_WEB_PUSH_PUBLIC_KEY'),
});

export default config;
